import Typography, { TypographyProps } from "@insite/mobius/Typography";
import * as React from "react";
import styled, { css } from "styled-components";

type Props = {
    text: string;
    backgroundColor?: string;
    color?: string;
};

export interface ProductDetailsProductBadgetsStyles {
    valueText?: TypographyProps;
}

export const productBadgetsStyles: ProductDetailsProductBadgetsStyles = {
    valueText: {
        size: 16,
    },
};

const styles = productBadgetsStyles;

const TextBadge = styled.div<{ backgroundColor: string; color: string }>`
    text-align: center;
    padding: 5px 8px;
    background-color: ${props => props.backgroundColor};
    color: ${props => props.color};
    border-radius: 5px;
`;

const ProductDetailsProductBadgets: React.FC<Props> = ({ text, backgroundColor, color }) => {
    return (
        <TextBadge backgroundColor={backgroundColor || "#000"} color={color || "#fff"}>
            <Typography as="p" {...styles.valueText}>
                {text}
            </Typography>
        </TextBadge>
    );
};

export default ProductDetailsProductBadgets;
